export default {
    new: 'Nuevo',
    add: 'Añadir',
    'view-invoice': 'Mostrar factura',
    'bond-no': 'Número de bono',
    edit: 'Editar',
    save: 'Guardar',
    bond: 'Bono',
    not: 'No',
    posted: 'Publicado',
    'delete-account-entry': 'Eliminar asiento contable',
    'are-you-sure-you-want-to-delete-the-entry': '¿Estas seguro de eliminar asiento contable?',
    'add-bond': 'Añadir Bono',
    'bond-date': 'Fecha de Bono',
    'create': 'Crear',
    'cancel': 'Cancelar',
    'sum': 'Total:',
    'difference': 'Diferencia:',
    'currency-equivalent': 'Saldo en otra moneda',
    'select-currency-to-show-the-currency-equivalent': 'Seleccionar la moneda a cambiar',

    headers: {
        sequence: 'Serial',
        account: 'Cuenta',
        debit: 'Débito',
        credit: 'Crédito',
        note: 'Descripción',
        currency: 'Moneda',
        'currency-debit': 'Ingresos en moneda extranjera',
        'currency-credit': 'Gastos en moneda extranjera',
        price: 'Precio',
        'paper-document-no': 'Ref. Doc.',
        'date': 'Fecha',
    },

    'not-posted-bonds': 'Bonos no arrastrados',
    'all-bonds-are-posted': 'Todos los bonos están arrastrados',

    'context-menu': {
        'account-statement' : 'Estado de cuenta',
        'edit' : 'Editar',
        'delete' : 'Eliminar'
    },

    'make-sure-the-data-entered-is-correct': 'Verificar los datos ingresados'
}